<script setup>
import EditMetrics from './metric/EditMetrics.vue';

import { reactive, onMounted, defineProps } from 'vue';
import { storeToRefs } from 'pinia';

import { useDashboardStore } from '../store/dashboard';

const props = defineProps({
    id: {
        type: [String, Number],
        required: true,
    },
});

const dashboardStore = useDashboardStore();
const { dashboard, dashboards } = storeToRefs(dashboardStore);

const createInitialState = () => {
    return reactive({
        // selectedUsers: [],
        selectedDepartments: [],
        submitted: false,
    });
};
const state = createInitialState();

onMounted(async () => {
    // Load dashboard details
    loadDashboardDetails();
});

const loadDashboardDetails = async () => {
    const dashboardId = parseInt(props.id);
    // Sadly load dashboard details by id doesnt exist
    // await dashboardStore.getDashboardDetails(props.id);
    // So we will load all dashboards and use id to extract it from there
    await dashboardStore.getDSDashboards({ paginate: false });
    // Get dashboard by id from the loaded dashboards
    const dashboardDetails = dashboards.value.find((dashboardObj) => dashboardObj.id === dashboardId);
    // console.log(dashboardDetails);
    // Now load the format into dashboard store
    await dashboardStore.loadEditDashboard(dashboardDetails);
};

const submit = async () => {
    state.submitted = true;
    if (isValid()) {
        const dashboardBody = {
            company_id: dashboard.value.company_id,
            name: dashboard.value.name,
            code: dashboard.value.code,
            default: dashboard.value.default,
            description: dashboard.value.description,
            metrics: dashboard.value.metrics,
            order: dashboard.value.order,
        };
        await dashboardStore.updateDashboard(dashboard.value.id, dashboardBody);
        state.submitted = false;
    }

    function isValid() {
        if (!dashboard.value.name) {
            return false;
        }
        return true;
    }
};
</script>
<template>
    <div class="card">
        <div class="grid">
            <div class="form-field col-6">
                <label for="name">Dashboard Name</label>
                <InputText maxlength = "255" id="name" :class="{ 'p-invalid': state.submitted && !dashboard.name }" v-model="dashboard.name" placeholder="Enter dashboard name" />
                <small v-if="state.submitted && !dashboard.name" class="p-invalid">Dashboard Name is mandatory.</small>
            </div>
            <div class="form-field col-6">
                <label for="code">Code</label>
                <InputText maxlength = "255" id="name" v-model="dashboard.code" :disabled="true" />
            </div>
        </div>
        <div class="form-field">
            <label for="description">Description:</label>
            <Textarea rows="3" id="description" v-model="dashboard.description" />
        </div>

        <div class="mt-3">
            <h5>Manage Metrics</h5>
            <edit-metrics v-if="dashboard.details" :metrics="dashboard.metrics" />
        </div>
        <Button label="Update" icon="pi pi-check" class="ml-2 p-button-primary" @click="submit" />
    </div>
</template>

<style lang="scss" scoped>
.form-field {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
}

.form-field label {
    margin-bottom: 0.5rem;
}
</style>
